import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

// // Translations
// import translationES from '%PUBLIC_URL%/es/translation.json'
// import translationEN from '%PUBLIC_URL%/en/translation.json'

// const resources = {
//   es: {
//     translation: translationES
//   },
//   en: {
//     translation: translationEN
//   }
// }

i18n
  // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
  // learn more: https://github.com/i18next/i18next-http-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    // resources,
    fallbackLng: 'es',
    whitelist: ['es', 'en'], //Array of abbrevations of the languages
    interpolation: {
      escapeValue: false
    },
    ns: ['translation'], //Names of the translation files
    backend: {
      loadPath: `${process.env.PUBLIC_URL}/locales/{{lng}}/{{ns}}.json`, //Path to the translation files
      addPath: `${process.env.PUBLIC_URL}/locales/add/{{lng}}/{{ns}}`
    },
    detection: {
      order: ['path'],
      lookupFromPathIndex: 0
    },
    debug: true
  })

export default i18n
